import { render, staticRenderFns } from "./aktualne-pocasie-detail.vue?vue&type=template&id=50df448b&"
import script from "./aktualne-pocasie-detail.vue?vue&type=script&lang=js&"
export * from "./aktualne-pocasie-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports